import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy, } from '@angular/core';
import { Right } from '../classes/Right';
import { Subscription } from 'rxjs';
import { AuthorizationService } from '../services/authorization.service';

/**
 * This will *ngIf a component. which will re-render it again if we clear() then createEmbeddedView();
 */
@Directive({
  selector: '[appHasRight]'
})
export class HasRightDirective implements OnInit, OnDestroy {

  private hasView: boolean = false;
  private componentRight: Right = null;
  private rightSubscription: Subscription;
  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef
    , private authorizationService: AuthorizationService) {
  }

  @Input() set appHasRight(componentRight: string) {
    this.componentRight = Right[componentRight];
  }

  ngOnInit(): void {
    this.rightSubscription = this.authorizationService.user.subscribe(user => {
      if (!user) {
        this.viewContainer.clear();
        this.hasView = false;
        return;
      }
      let hasRight = user.Privileges.includes(this.componentRight);
      if (hasRight && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!hasRight && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.rightSubscription.unsubscribe();
  }

}
